export const updateTheme = action => ({
    type: 'UPDATE_THEME',
    payload: action
});
export const modifyTheme = action => ({
    type: 'MODIFY_THEME',
    payload: action
});